const accessUsers = {

    PROFILE: { name: 'Profile', path: '/profile' },
    UPDATE_PROFILE: { name: 'Update Profile', path: '/update-profile' },

}

export default accessUsers;